import SearchLessonsWithModulesRequestModelBase from '../_generated/modelBases/search-lessons-with-modules-request-model-base';

export default class SearchLessonsWithModulesRequestModel extends SearchLessonsWithModulesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
